'use client'
import type { MsgDeskPageProps } from '../MsgDeskApp'
import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { MusicLoading } from '../components/music/MusicLoading'
import { MusicRoutedPage } from '../components/music/MusicRoutedPage'
function RoutedPage(props: MsgDeskPageProps) { return <MusicRoutedPage {...props} kind="musictrack" /> }
export default function MusictrackSurfaceClient(props: DeskSurfaceClientProps) { return <MsgDeskSurfaceClient {...props} RoutedPage={RoutedPage} Loading={MusicLoading} /> }
